module.exports = __webpack_public_path__ + "media/track_guides/icon-e3c8079a.png";